export const motionComponentSymbol = Symbol.for("motionComponentSymbol")
